import Lodash from 'lodash';

export default {
    methods: {
        tranformDate2Epoch: (date) => {
            if(date == null || date == undefined)
                return null;
                            
            var utcDate = Date.UTC(
                date.getUTCFullYear(), 
                date.getUTCMonth(), 
                date.getUTCDate(),
                date.getUTCHours(), 
                date.getUTCMinutes(), 
                date.getUTCSeconds(), 
                date.getMilliseconds()
            );

            return new Date(utcDate).getTime();
        },
        tranformEpoch2Date: (date) => {
            if(date == null || date == undefined)
                return null;

            return new Date(Lodash.parseInt(date, 10));
        },        
        firstDayOfMonth: (date) => {
            if(date == null || date == undefined)
                return null;
                            
            return new Date(date.getFullYear(), date.getMonth(), 1);
        },
        lastDayOfMonth: (date) => {
            if(date == null || date == undefined)
                return null;
                            
            return new Date(date.getFullYear(), date.getMonth() + 1, 0);
        },
        convertUtcToLocal(date){
            if(date == null || date == undefined)
                return null;
                            
            return this.$moment.utc(date).local();
        },       
        formatUtcToLocal(date){
            if(date == null || date == undefined)
                return null;
                            
            return this.convertUtcToLocal(date).format("DD/MM/YYYY HH:mm:ss");
        },            
        formatUtcDate(date){
            if(date == null || date == undefined)
                return null;
                            
            return this.$moment.utc(date).format("DD/MM/YYYY");
        },           
        getLocale() {
            let locale = localStorage.getItem("locale");
            if(locale == null)
                return "pt-br";
            
            return locale;
        },   
        getTimespan(dataInicio, dataTermino){            
            if(dataInicio == null || dataInicio == undefined) return null;
            if(dataTermino == null || dataTermino == undefined) return null;

            const startDate = this.$moment(dataInicio);
            const endDate = this.$moment(dataTermino);

            const difference = endDate.diff(startDate);
            const duration = this.$moment.duration(difference);

            let timespan = null;
            let hours = Math.floor(duration.asHours());

            if(hours < 10){
                timespan = `0${hours}`;
            }
            else{
                if(hours / 24 > 1){
                    if(hours % 24 < 10){
                        timespan = `0${hours % 24}`;
                    }      
                    else{
                        timespan = hours % 24;
                    }              

                    return `${Math.trunc(hours / 24)}d ` + timespan + this.$moment(difference).format(":mm:ss");
                }
                else{
                    timespan = hours;
                }
            }

            return timespan += this.$moment(difference).format(":mm:ss");  
        },
        createPeriodFromNowToPast(value, period){
            if(value == undefined || value == null) value = 1;
            if(period == undefined || period == null) period = "months";

            let now = new Date();
            return [
                this.$moment(now).subtract(value, period).toDate(),
                this.$moment(now).toDate()
            ]; 
        },
        createPeriodFromNowToFuture(value, period){
            if(value == undefined || value == null) value = 1;
            if(period == undefined || period == null) period = "months";

            let now = new Date();
            return [
                this.$moment(now).add(value, period).toDate(),
                this.$moment(now).toDate()
            ]; 
        },               
        setFirstHourTime(date){
            if(date == null || date == undefined)
                return null;
              
            date.setHours(0)
            date.setMinutes(0);
            date.setSeconds(0);
            date.setMilliseconds(0);   
            return date;
        },               
        setLastHourTime(date){
            if(date == null || date == undefined)
                return null;
                          
            date.setHours(23)
            date.setMinutes(59);
            date.setSeconds(59); 
            date.setMilliseconds(999);  
            return date;
        }
    }
}